export default [
   {'const': 'B', 'title': 'Bumiputra'},
   {'const': 'M', 'title': 'Malay'},
   {'const': 'C', 'title': 'Chinese'},
   {'const': 'I', 'title': 'Indian'},
   {'const': 'O', 'title': 'Others'},
   {'const': 'R', 'title': 'Refuse to answer'},
]
